import React from "react";
import { useState, useEffect } from 'react';
import { uf_addTimeStr } from '../../modules/utils.mjs'

import '../../index.css';

const SipTable = ({
    serial,
    data,
    updateTable,
    mqttReq
}) => {
    const [tableSipState, setTableSipState] = useState([]);

    const [utenteSipState, setUtenteSipState] = useState('')
    const [passwordSipState, setPasswordSipState] = useState('')
    const [portSipState, setPortSipState] = useState('')
    const [realmState, setRealmState] = useState('')
    const [domainState, setDomainState] = useState('')
    const [destinatarioState, setDestinatarioState] = useState('') // DB Version 0
    const [updateSipTableState, setUpdateSipTableState] = useState('')
    const handleUtenteSipChange = (event) => { setUtenteSipState(event.target.value) }
    const handlePasswordSipChange = (event) => { setPasswordSipState(event.target.value) }
    const handlePortSipChange = (event) => { setPortSipState(event.target.value) }
    const handleRealmChange = (event) => { setRealmState(event.target.value) }
    const handleDomainChange = (event) => { setDomainState(event.target.value) }
    const handleDestinatarioChange = (event) => { setDestinatarioState(event.target.value) } // DB Version 0

    const [includeUser, setIncludeUser] = useState(false);
    const [includePwd, setIncludePwd] = useState(false);
    const [includePort, setIncludePort] = useState(false);
    const [includeRealm, setIncludeRealm] = useState(false);
    const [includeDomain, setIncludeDomain] = useState(false);
    const [includeDest, setIncludeDest] = useState(false); // DB Version 0

    useEffect(() => {
        if ((data !== null) && (data !== undefined))
            uf_addTimeStr(data)
        setTableSipState(data)
    }, [data]);

    function prepareupdatesiptable() {
        if (tableSipState?.user != null) setUtenteSipState(tableSipState.user);
        if (tableSipState?.port != null) setPortSipState(tableSipState.port);
        if (tableSipState?.realm != null) setRealmState(tableSipState.realm);
        if (tableSipState?.domain != null) setDomainState(tableSipState.domain);
        if (tableSipState?.dest != null) setDestinatarioState(tableSipState.dest); // DB Version 0
    }

    function updatesiptable() {
        const post_body = {
            serial: serial,
            ...(includeUser && { user: utenteSipState }),
            ...(includePwd && { pwd: passwordSipState }),
            ...(includePort && { port: portSipState.toString() }),
            ...(includeRealm && { realm: realmState }),
            ...(includeDomain && { domain: domainState }),
            ...(includeDest && { dest: destinatarioState }), // DB Version 0
        };
        updateTable(post_body, '/sipmqttset', setUpdateSipTableState)
    }

    function refreshsiptable() {
        mqttReq(serial, '/sipmqttreq')
    }

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`GatewayDBTable-Section ${isOpen ? 'open' : ''}`}>
            <button onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: '10px' }}>
                {isOpen ? 'Nascondi SIP' : 'Mostra SIP'}
            </button>
            {isOpen && (
                <table className="GatewayDBTable">
                    <colgroup>
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "5%" }} />
                    </colgroup>
                    <tbody>
                        {/* Title row */}
                        <tr>
                            <th className="tabletitle" colSpan="4">SIP</th>
                        </tr>

                        {/* Header row */}
                        <tr>
                            <th className="title">Campo</th>
                            <th className="title">Valore attuale</th>
                            <th className="title">Nuovo valore</th>
                            <th className="title">✔</th>
                        </tr>

                        {/* Utente row */}
                        <tr>
                            <td>Utente</td>
                            <td style={{ textAlign: 'center' }}>{tableSipState?.user}</td>
                            <td>
                                <input type="text" value={utenteSipState} onChange={handleUtenteSipChange} />
                            </td>
                            <td>
                                <input type="checkbox" checked={includeUser} onChange={() => setIncludeUser(!includeUser)} />
                            </td>
                        </tr>

                        {/* Password row */}
                        <tr>
                            <td>Password</td>
                            <td className="noinput"></td>
                            <td>
                                <input type="text" value={passwordSipState} onChange={handlePasswordSipChange} />
                            </td>
                            <td>
                                <input type="checkbox" checked={includePwd} onChange={() => setIncludePwd(!includePwd)} />
                            </td>
                        </tr>

                        {/* Port row */}
                        <tr>
                            <td>Port</td>
                            <td style={{ textAlign: 'center' }}>{tableSipState?.port}</td>
                            <td>
                                <input type="text" value={portSipState} onChange={handlePortSipChange} />
                            </td>
                            <td>
                                <input type="checkbox" checked={includePort} onChange={() => setIncludePort(!includePort)} />
                            </td>
                        </tr>

                        {/* Realm row */}
                        <tr>
                            <td>Realm</td>
                            <td style={{ textAlign: 'center' }}>{tableSipState?.realm}</td>
                            <td>
                                <input type="text" value={realmState} onChange={handleRealmChange} />
                            </td>
                            <td>
                                <input type="checkbox" checked={includeRealm} onChange={() => setIncludeRealm(!includeRealm)} />
                            </td>
                        </tr>

                        {/* Domain row */}
                        <tr>
                            <td>Domain</td>
                            <td style={{ textAlign: 'center' }}>{tableSipState?.domain}</td>
                            <td>
                                <input type="text" value={domainState} onChange={handleDomainChange} />
                            </td>
                            <td>
                                <input type="checkbox" checked={includeDomain} onChange={() => setIncludeDomain(!includeDomain)} />
                            </td>
                        </tr>

                        {/* Destinatario row DB Version 0 */}
                        {tableSipState?.dest && (
                        <tr>
                            <td style={{color: "red"}}>Destinatario</td>
                            <td style={{ textAlign: 'center' }}>{tableSipState?.dest}</td>
                            <td>
                                <input type="text" value={destinatarioState} onChange={handleDestinatarioChange} />
                            </td>
                            <td>
                                <input type="checkbox" checked={includeDest} onChange={() => setIncludeDest(!includeDest)} />
                            </td>
                        </tr>
                        )}

                        {/* Ultimo aggiornamento row */}
                        <tr>
                            <td className="timetitle">Ultimo aggiornamento</td>
                            <td style={{ textAlign: "center" }}>{tableSipState?.time}</td>
                            <td style={{ textAlign: "center" }}>{updateSipTableState}</td>
                        </tr>

                        {/* Buttons row */}
                        <tr>
                            <td colSpan="3" style={{ textAlign: "center" }}>
                                <button onClick={refreshsiptable} style={{ marginRight: '20px' }}>aggiorna</button>
                                <button onClick={prepareupdatesiptable} style={{ marginRight: '20px' }}>&gt;</button>
                                <button onClick={updatesiptable}>invia</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default SipTable;
